/**
 * エラー関連のutilクラス。
 */
export class ErrorUtils {

	/**
	 * エラーメッセージを表示する。
	 * 
	 * @param error 
	 */
	static alert(error: any) {
		if (error.response?.data != undefined) {
			alert(error.response.data);
		} else {
			alert('以下のエラーが発生しました。\n\n' + error);
		}
	}
}